import { useCustomers } from 'hooks/useCustomers';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Col, FlexboxGrid, Grid, Panel, Tag } from 'rsuite';

import EditCustomerDialog from '../dialogs/EditCustomerDialog';
import { NotFound } from './NotFound';

const CustomerDetailsScreen = () => {
    const navigate = useNavigate();
    const { customerId } = useParams();
    const { customers } = useCustomers();
    const customer = customers.find(c => c.id === Number(customerId));

    if (!customer) return <NotFound message="Customer not found!" />;

    return (
        <>
            <Grid fluid>
                <Col xs={24}>
                    <Panel
                        bordered
                        header={
                            <FlexboxGrid justify="start" align="middle">
                                <h1 style={{ display: 'inline' }}>{customer.name}</h1>&nbsp;
                                <Tag>
                                    <h4>Customer</h4>
                                </Tag>
                                {customer.is_confidential && (
                                    <Tag color="red">
                                        <h4>Confidential</h4>
                                    </Tag>
                                )}
                            </FlexboxGrid>
                        }
                        style={{ marginBottom: '24px' }}
                    >
                        <FlexboxGrid
                            justify="start"
                            align="middle"
                            style={{ paddingTop: 20, gap: 5 }}
                        >
                            <Button appearance="default" onClick={() => navigate(-1)}>
                                Close
                            </Button>
                            <EditCustomerDialog editable={customer}>
                                <Button appearance="primary">Edit</Button>
                            </EditCustomerDialog>
                        </FlexboxGrid>
                    </Panel>
                </Col>
            </Grid>
        </>
    );
};

export default CustomerDetailsScreen;
